import {
  EIdentificationPersonType,
  ECommercialOwnershipVerificationFormViewFields,
  EIdentificationPersonTypeExtended,
} from '../../enums';

export type TFieldByType = {
  [K in EIdentificationPersonTypeExtended]: {
    visible: ECommercialOwnershipVerificationFormViewFields[];
    require: ECommercialOwnershipVerificationFormViewFields[];
  };
};

export const fieldsByType: TFieldByType = {
  [EIdentificationPersonType.Natural]: {
    visible: [
      ECommercialOwnershipVerificationFormViewFields.CadastralNumber,
      ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType,
      ECommercialOwnershipVerificationFormViewFields.LastName,
      ECommercialOwnershipVerificationFormViewFields.FirstName,
      ECommercialOwnershipVerificationFormViewFields.SecondName,
    ],
    require: [
      ECommercialOwnershipVerificationFormViewFields.CadastralNumber,
      ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType,
      ECommercialOwnershipVerificationFormViewFields.LastName,
      ECommercialOwnershipVerificationFormViewFields.FirstName,
    ],
  },
  [EIdentificationPersonType.Ip]: {
    visible: [
      ECommercialOwnershipVerificationFormViewFields.CadastralNumber,
      ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType,
      ECommercialOwnershipVerificationFormViewFields.Inn,
      ECommercialOwnershipVerificationFormViewFields.LastName,
      ECommercialOwnershipVerificationFormViewFields.FirstName,
      ECommercialOwnershipVerificationFormViewFields.SecondName,
    ],
    require: [
      ECommercialOwnershipVerificationFormViewFields.CadastralNumber,
      ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType,
      ECommercialOwnershipVerificationFormViewFields.Inn,
      ECommercialOwnershipVerificationFormViewFields.LastName,
      ECommercialOwnershipVerificationFormViewFields.FirstName,
    ],
  },
  [EIdentificationPersonType.Legal]: {
    visible: [
      ECommercialOwnershipVerificationFormViewFields.CadastralNumber,
      ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType,
      ECommercialOwnershipVerificationFormViewFields.Inn,
      ECommercialOwnershipVerificationFormViewFields.CompanyName,
    ],
    require: [
      ECommercialOwnershipVerificationFormViewFields.CadastralNumber,
      ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType,
      ECommercialOwnershipVerificationFormViewFields.Inn,
    ],
  },
  none: {
    visible: [
      ECommercialOwnershipVerificationFormViewFields.CadastralNumber,
      ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType,
    ],
    require: [
      ECommercialOwnershipVerificationFormViewFields.CadastralNumber,
      ECommercialOwnershipVerificationFormViewFields.IdentificationPersonType,
    ],
  },
};
